import { BusyButton } from '../BusyButton'
import React from 'react'

export type RefreshButtonProps = {
  loading?: boolean
  onClick?: (e: any) => void
  refetch?: (variables?: Partial<any>) => Promise<any>
  text?: string
  title?: string
}
export const RefreshButton = ({
  loading,
  onClick,
  refetch,
  text = 'Refresh',
  title = 'Refresh the information.',
}: RefreshButtonProps) => {
  const _onClick = async (e: any) => {
    if (onClick) return onClick(e)
    await refetch()
  }

  return <BusyButton icon="refresh" text={text} title={title} isBusy={loading} onClick={(r) => _onClick(r)} />
}
